import { Icon } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { type HTMLAttributes, type PropsWithChildren } from "react";
import styles from "./AssistantPrompt.module.css";

const cx = classNames.bind(styles);

export const AssistantPrompt = ({
  children,
  ...restProps
}: PropsWithChildren<HTMLAttributes<HTMLButtonElement>>) => {
  return (
    <button
      className={cx("container", restProps.className)}
      {...restProps}
    >
      {children}
      <Icon
        variant="arrow-down-right"
        size={16}
      />
    </button>
  );
};
